import "./App.css";
import Dictionary from "./Dictionary";

function App() {
  return (
    <div className="App">
      <div className="container">
        <header className="App-header">hello</header>
        <main>
          <Dictionary />
        </main>
        <footer className="App-footer">
          {" "}
          <small>Coded by Kristina Poliukhovych</small>
        </footer>
      </div>
    </div>
  );
}

export default App;
